import { AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { debounceTime } from 'rxjs/operators';
import { TabSearchParameter } from '../../../core/model/tab-search-parameter.model';
import { ConfigService } from '../../../core/services/config.service';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { TabService } from '../../../core/services/tab.service';
import { OutlyingPoint } from './../../../core/model/outlying-point.model';
import { TerminalCommonInfo } from './../../../core/model/terminal-common-info.model';
import { AppUtilityService } from './../../../core/services/app-utility.service';



/**
 * @export
 * @class OutlyingPointDisplayDataComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'lms-outlying-point-display-data',
  templateUrl: './outlying-point-display-data.component.html',
  styleUrls: ['./outlying-point-display-data.component.scss']
})
export class OutlyingPointDisplayDataComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() oulyingData: Array<OutlyingPoint>; // Original List we are getting from Service
  oulyingDataDisplay: Array<OutlyingPoint>; // List to be displayed on Page
  sortedData: Array<OutlyingPoint>; // List to be displayed on Page through sorting
  totalRecords: number; // Total no of records on Page
  showingFrom: number; // This shows from value on Pagination
  showingTo: number; // This shows to value on Pagination
  scrollHeight: number; // This is the scroll height
  upperHeight = 247; // this is the header parts height
  terminalMnemonic: string; // This is terminal which is showing on outlying point data
  scrollableBody: any; // This is scrollable body used for pagination
  commonopsPicklist: any; // This is used for getting Common Pick List data
  terminalCommonInfoArr: Array<TerminalCommonInfo>; // This is terminal info array which we are using for getting City and state
  outlyingDataLabel: any; // Get Outyling Data label from Config Service;
  sortType: any; // Tells the sort field
  sortDirection: string; // Tell the sort Direction
  listOfId: Array<string>;
  terminalName: string;
  popUpHeader: string;
  countPop: boolean;
  tabLevel: number;
  @ViewChild('viewPortPaging') viewPageDirective;

  /**
   * Creates an instance of OutlyingPointDisplayDataComponent.
   * @param {AppUtilityService} appUtilityService
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {Router} router
   * @memberof OutlyingPointDisplayDataComponent
   */
  constructor(private appUtilityService: AppUtilityService, private lmsRendererService: LmsRendererService,
    private staticDataStoreService: StaticDataStoreService, private router: Router,
    private configService: ConfigService, private tabService: TabService,
    private messageHandlerService: MessageHandlerService) {
    this.outlyingDataLabel = this.configService.getConfigData().outlyingPointLabel;
    this.tabLevel = this.configService.getConfigData().tabIndex.detailPage;
    this.commonopsPicklist = this.staticDataStoreService.getValue(this.outlyingDataLabel.commonopsPicklist);
    if (this.commonopsPicklist && this.commonopsPicklist.setOfTerminals) {
      this.terminalCommonInfoArr = [];
      this.terminalCommonInfoArr = this.commonopsPicklist.setOfTerminals;
    }
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
        this.calculatePageHeight();
      }
    });
    this.resetSortType();
    this.sortDirection = 'asc';
  }

  ngOnInit() {
    this.calculatePageHeight();
  }

  private calculatePageHeight() {
    let heightToAdjust = 0;
    if (this.lmsRendererService.getWindowWidth() < 1280) {
      heightToAdjust = 21;
    }
    this.scrollHeight = this.lmsRendererService.getWindowHeight() - this.upperHeight - heightToAdjust;
  }

  /**
   * Method used to set Pagination
   * @memberof OutlyingPointDisplayDataComponent
   */
  ngOnChanges() {
    if (this.oulyingData && this.oulyingData.length > 0) {
      let data = [];
      const commonopsPicklist = this.staticDataStoreService.getValue(this.outlyingDataLabel.commonopsPicklist);
      if (commonopsPicklist) {
        data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
        for (const outlying of this.oulyingData) {
          outlying.milepost = [];
          for (const key in data) {
            if (data[key].trim().toLowerCase() === outlying.termMnemonic.trim().toLowerCase()) {
              outlying.milepost.push(key);
            }
          }
        }
      }
      this.oulyingDataDisplay = this.oulyingData;
      this.totalRecords = this.oulyingDataDisplay.length;
      setTimeout(() => {
        this.resetDatatableScroll();
        this.resetSortType();
        this.adjustHeightAndPagination();
        if (this.viewPageDirective) {
          this.viewPageDirective.updateScreenSizeSetting();
        }
      }, 20);
    } else {
      this.showingFrom = 0;
      this.showingTo = 0;
      this.totalRecords = 0;
    }
    this.terminalMnemonic = '';
  }

  /**
   * Method used to set Pagination
   * @memberof OutlyingPointDisplayDataComponent
   */
  ngAfterViewInit() {
    this.adjustHeightAndPagination();
  }

  /**
   * Reset Scroll
   * @memberof OutlyingPointDisplayDataComponent
   */
  resetDatatableScroll() {
    const outlyingTable = document.getElementById(this.outlyingDataLabel.outlyingPointDataId);
    if (outlyingTable) {
      const scrollableBody = outlyingTable;
      scrollableBody.scrollTop = 0;
    }
  }

  /**
   * Adjust Scroll bar
   * @private
   * @memberof OutlyingPointDisplayDataComponent
   */
  private adjustHeightAndPagination() {
    const outlyingTable = document.getElementById(this.outlyingDataLabel.outlyingPointDataId);
    const outlyingHeader = document.getElementById('outlying-table-header');
    if (outlyingHeader && outlyingTable) {
      const items = outlyingTable.querySelectorAll('.outlying-table-data');
      if ((outlyingTable.clientHeight / 40) < items.length) {
        const scrollWidth = outlyingTable.offsetWidth - outlyingTable.clientWidth;
        outlyingHeader.setAttribute('style', `margin-right: ${scrollWidth}px !important`);
      } else {
        outlyingHeader.removeAttribute('style');
      }
    }

  }

  getPaginationData($event) {
    this.showingFrom = $event.paging.start;
    this.showingTo = $event.paging.end;
  }

  /**
   * Method used for retrieve city, state for terminal mnemonic.
   * @param {string} terminalMnemonic
   * @returns {string}
   * @memberof OutlyingPointDisplayDataComponent
   */
  getTerminalCityState(terminalMnemonic: string): string {
    return this.appUtilityService.getTerminalCityState(terminalMnemonic);
  }

  /**
   * @param {string} value
   * @param {string} terminal
   * @memberof OutlyingPointDisplayDataComponent
   */
  openPopUp(listOfId: Array<string>, terminal: string, header: string) {
    this.listOfId = listOfId;
    this.terminalName = terminal;
    this.popUpHeader = header;
    if (this.listOfId && this.listOfId.length > 0) {
      this.countPop = true;
    }
  }

  /**
   * This method navigates to Particular Screen
   * @param {string} id
   * @memberof OutlyingPointDisplayDataComponent
   */
  navigateToScreen(id: string) {
    if ('Terminating - Trains' === this.popUpHeader || 'Originating - Trains' === this.popUpHeader) {
      const tabSearchParameter = <TabSearchParameter>({ searchText: id });

      window.open(
        window.location.href.split('?')[0] + '?type=train&subtype=data&search=' + tabSearchParameter.searchText,
        '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
      );
    } else {
      const tabSearchParameter = <TabSearchParameter>({ searchText: this.appUtilityService.UIformatLocomotiveId(id) });

      window.open(
        window.location.href.split('?')[0] + '?type=locomotive&subtype=data&search=' + tabSearchParameter.searchText,
        '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
      );
    }

  }

  /**
   *
   *
   * @param {string} subType
   * @param {string} type
   * @param {string} terminalMnemonic
   *
   * @memberof OutlyingPointDisplayDataComponent
   */
  public showTerminalTabData(subType: string, type: string, terminalMnemonic: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: terminalMnemonic });
    
    window.open(
      window.location.href.split('?')[0] + '?type='+ type.toLowerCase()  +'&subtype='+ subType.toLowerCase()  +'&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
   * Filter Method
   * @memberof OutlyingPointDisplayDataComponent
   */
  public filterList(event) {
    if (event) {
      event.stopPropagation();
    }
    const data = this.sortedData && this.sortedData.length > 0 ? this.sortedData : this.oulyingData;
    const mnemonic = this.terminalMnemonic.trim().toLowerCase();
    this.oulyingDataDisplay = data.filter((rowData) => {
      if (rowData.termMnemonic.trim().toLowerCase().startsWith(mnemonic)) {
        return true;
      } else {
        for (let i = 0; i < rowData.milepost.length; i++) {
          if (rowData.milepost[i].trim().toLowerCase().startsWith(mnemonic)) {
            return true;
          }
        }
      }
      return false;
    });
    this.totalRecords = this.oulyingDataDisplay.length;
    setTimeout(() => {
      this.resetDatatableScroll();
      this.adjustHeightAndPagination();
      if (this.viewPageDirective) {
        this.viewPageDirective.updateScreenSizeSetting();
      }
    }, 20);
  }

  /**
   * This method sorts data
   * @param {string} value
   * @memberof OutlyingPointDisplayDataComponent
   */
  sortData(value: string) {
    if (!this.sortType[value]) {
      this.sortDirection = value !== 'termMnemonic' ? 'desc' : 'asc';
    }
    this.resetSortType();
    this.sortType[value] = this.sortDirection;
    if ('desc' === this.sortDirection) {
      this.sortDirection = 'asc';
      this.oulyingDataDisplay = _.orderBy(this.oulyingDataDisplay, [value, 'termMnemonic'], ['desc', 'desc']);
      this.sortedData = _.orderBy(this.oulyingData, [value, 'termMnemonic'], ['desc', 'desc']);
    } else {
      this.sortDirection = 'desc';
      this.oulyingDataDisplay = _.orderBy(this.oulyingDataDisplay, [value, 'termMnemonic'], ['asc', 'asc']);
      this.sortedData = _.orderBy(this.oulyingData, [value, 'termMnemonic'], ['asc', 'asc']);
    }
  }

  /**
   * This resets sort order
   * @memberof OutlyingPointDisplayDataComponent
   */
  resetSortType() {
    this.sortType = {
      termMnemonic: '',
      terminatingTrains: '',
      terminatingLocos: '',
      originatingTrains: '',
      originatingLocos: '',
      roadLocos: '',
      yardLocalLocos: '',
      mowLocos: '',
      totalLocosOnTerm: ''
    };
    this.sortedData = undefined;
  }

  /**
   * Close Pop Up
   * @memberof OutlyingPointDisplayDataComponent
   */
  closePop() {
    this.countPop = false;
  }

}
